import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import CSS from "bootstrap/dist/css/bootstrap.css";
import App from "App";

import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import store from "redux/store";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
